export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  content: string;
  imageUrl: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'dajiba-origin-history',
    title: '大鸡巴品种的起源与历史演变',
    excerpt: '追溯大鸡巴品种数百年的育种历史，从地方土鸡到特色品种的发展历程，了解其地理分布与遗传多样性。',
    category: 'origin',
    categoryName: '品种起源',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20agricultural%20scroll%20painting%20style%20depicting%20traditional%20farm%20scene%20with%20large%20chickens%20in%20a%20village%20setting%2C%20ink%20wash%20with%20warm%20sepia%20tones%2C%20classical%20Chinese%20art%20aesthetic%2C%20detailed%20roosters%20and%20hens%20among%20bamboo%20and%20thatched%20houses%2C%20historical%20atmosphere&width=800&height=400&seq=article-origin-history&orientation=landscape',
    content: `<p>大鸡巴作为我国传统特色家禽品种之一，其历史可追溯至明清时期。该品种主要分布在华东和华南地区，经过数百年的自然选择与人工选育，逐渐形成了今天我们所熟知的优良品种。</p>
    <h2>历史渊源</h2>
    <p>据《中国畜禽遗传资源志》记载，大鸡巴品种的原始种群最早出现在江南水乡地区。当地湿润的气候、丰富的自然资源以及独特的农耕文化，为这一品种的形成提供了得天独厚的条件。</p>
    <p>在明清两代，随着商品经济的发展和人口的增长，对优质禽肉和禽蛋的需求不断增加。当地农民开始有意识地对体型较大、生长速度较快的个体进行选留和繁育，逐步固化了这些优良性状。</p>
    <h2>地理分布</h2>
    <p>大鸡巴品种的核心产区主要分布在长江中下游平原及周边丘陵地带，包括江苏南部、浙江北部、安徽东南部以及江西东北部等地区。这些区域水源充沛、气候温和，非常适宜家禽养殖。</p>
    <p>近年来，随着品种推广力度的加大，其养殖范围已扩展至全国二十多个省份。特别是在华南和西南地区，大鸡巴品种因其适应性强、肉质优良等特点而受到养殖户的广泛欢迎。</p>
    <h2>育种历程</h2>
    <p>二十世纪八十年代以来，我国农业科研机构对大鸡巴品种进行了系统的保种和选育工作。通过建立核心保种群、实施科学的选配方案，使得品种的遗传多样性得到了有效保护，同时生产性能也得到了显著提升。</p>
    <p>进入二十一世纪，分子标记辅助选择等现代育种技术的应用，进一步加快了品种改良的进程。如今的大鸡巴品种既保留了传统的地方品种特色，又具备了现代商业化生产所需的优良性能。</p>`,
    date: '2026-07-25',
    readTime: '8分钟',
    tags: ['品种起源', '历史渊源', '地理分布', '育种历程'],
  },
  {
    slug: 'dajiba-physical-traits',
    title: '大鸡巴外形特征详解：从冠型到羽色的全面识别指南',
    excerpt: '全面解析大鸡巴品种的体型结构、羽毛颜色、冠型特征等外表识别要点，帮助养殖户快速准确辨识纯种个体。',
    category: 'appearance',
    categoryName: '外形特征',
    imageUrl: 'https://readdy.ai/api/search-image?query=Detailed%20anatomical%20illustration%20style%20showing%20a%20magnificent%20rooster%20with%20rich%20golden%20red%20plumage%20and%20large%20red%20comb%2C%20standing%20on%20a%20wooden%20fence%20post%20against%20a%20soft%20countryside%20backdrop%2C%20warm%20morning%20light%2C%20every%20feather%20clearly%20defined%2C%20natural%20history%20illustration%20aesthetic&width=800&height=400&seq=article-physical-traits&orientation=landscape',
    content: `<p>大鸡巴品种以其独特的外形特征在家禽界享有盛誉。准确识别这些特征对于品种选育和品质鉴定具有重要意义。本文将从多个维度详细解读该品种的外形特点。</p>
    <h2>体型结构</h2>
    <p>大鸡巴成鸡体型较大，体躯呈长方形，胸部宽阔而深，背部平直且较长。成年公鸡体重可达3.5至4.5千克，母鸡体重在2.8至3.5千克之间。其骨骼粗壮、肌肉发达，整体给人以健壮有力的视觉感受。</p>
    <p>颈部长度适中，与体躯比例协调。尾部发达，公鸡尾羽长而弯曲，呈镰刀状上翘，极具观赏价值。双腿粗壮有力，胫部长度适中，趾爪坚硬，适合散养环境下的觅食活动。</p>
    <h2>羽毛颜色</h2>
    <p>大鸡巴品种的羽毛色彩丰富而富有层次感。公鸡羽毛以金红色为主调，颈部披肩羽呈亮丽的金黄色，背部和鞍部羽毛为深红褐色，尾部飞羽呈墨绿色带有金属光泽。在阳光照射下，整体羽色流光溢彩，极具视觉冲击力。</p>
    <p>母鸡羽色相对素雅，以浅棕色或麻黄色为主，全身散布细密的黑色斑纹，形成良好的保护色。这种性别二态性的羽色分化，是长期自然选择的结果。</p>
    <h2>冠型特征</h2>
    <p>大鸡巴品种以单冠为主，冠体大而直立，冠齿分明，通常有5至7个冠齿。健康的成鸡冠色鲜红，质地饱满有弹性，这是判断鸡只健康状况的重要指标之一。</p>
    <p>公鸡的冠和肉垂明显大于母鸡，颜色更为鲜艳。在繁殖季节，公鸡的冠色会变得更加红润，这是雄性激素水平升高的外在表现。</p>`,
    date: '2026-07-20',
    readTime: '10分钟',
    tags: ['外形特征', '体型结构', '羽毛颜色', '冠型识别'],
  },
  {
    slug: 'dajiba-breeding-tech',
    title: '大鸡巴科学养殖技术全攻略',
    excerpt: '从育雏到成鸡，系统介绍大鸡巴品种的科学养殖方法，涵盖温度控制、光照管理、密度规划等关键技术要点。',
    category: 'breeding',
    categoryName: '养殖技术',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20poultry%20farm%20with%20modern%20equipment%2C%20neat%20rows%20of%20chicken%20coops%20with%20automatic%20feeding%20systems%2C%20healthy%20chickens%20in%20clean%20environment%2C%20bright%20natural%20lighting%20through%20large%20windows%2C%20organized%20agricultural%20facility%2C%20warm%20wood%20and%20white%20color%20scheme&width=800&height=400&seq=article-breeding-tech&orientation=landscape',
    content: `<p>科学的养殖技术是大鸡巴品种发挥最大生产潜力的关键。本文将从育雏期、育成期到产蛋期，系统介绍各阶段的养殖管理要点。</p>
    <h2>育雏期管理</h2>
    <p>大鸡巴雏鸡出壳后的前四周为关键育雏期。此阶段需要严格控制育雏室的温度和湿度。第一周温度应维持在33至35摄氏度，之后每周降低2至3摄氏度，直至与室外温度相适应。</p>
    <p>育雏密度以每平方米25至30只为宜，随着日龄增长逐步降低密度。光照方面，前三日保持24小时光照，之后逐步过渡到自然光照周期。开食料应选择优质雏鸡专用配合饲料，确保蛋白质含量在20%以上。</p>
    <h2>育成期管理</h2>
    <p>5至18周龄为大鸡巴的育成期。此阶段鸡只生长发育迅速，对营养的需求量较大。饲料中粗蛋白含量应保持在16%至18%，同时注意钙磷比例平衡。</p>
    <p>育成期建议采用地面平养或网上平养方式，饲养密度控制在每平方米8至10只。定期进行称重和均匀度检测，根据体重情况及时调整饲喂方案，确保鸡群整齐度。</p>
    <h2>产蛋期管理</h2>
    <p>大鸡巴品种一般在18至20周龄开始产蛋。产蛋高峰期饲料中的粗蛋白含量需达到17%至18%，钙含量不低于3.5%。每日光照时间应稳定在16小时，光照强度为每平方米10至15勒克斯。</p>
    <p>产蛋箱应设置在安静、光线较暗的位置，每4至5只母鸡配备一个产蛋箱。及时收集鸡蛋，保持产蛋箱清洁干燥，可有效减少脏蛋和破损蛋的比例。</p>`,
    date: '2026-07-15',
    readTime: '12分钟',
    tags: ['养殖技术', '育雏管理', '饲料配比', '光照控制'],
  },
  {
    slug: 'dajiba-feeding-guide',
    title: '大鸡巴饲养管理实用手册：饲料配比与日常管理',
    excerpt: '详解大鸡巴各生长阶段的精准饲料配比方案、饲喂频次与饮水管理，附常见饲料原料营养价值表。',
    category: 'feeding',
    categoryName: '饲养管理',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rustic%20farm%20scene%20with%20a%20farmer%20carefully%20mixing%20organic%20chicken%20feed%20in%20a%20large%20wooden%20trough%2C%20surrounded%20by%20curious%20healthy%20chickens%2C%20warm%20afternoon%20sunlight%2C%20traditional%20farming%20atmosphere%2C%20natural%20earthy%20colors%2C%20documentary%20style%20photography&width=800&height=400&seq=article-feeding-guide&orientation=landscape',
    content: `<p>合理的饲养管理是保障大鸡巴品种健康和生产性能的基础。本文围绕饲料配比、饲养环境和日常管理等方面，提供实用的操作指导。</p>
    <h2>饲料配方原则</h2>
    <p>大鸡巴品种的饲料配方应根据不同生长阶段和生产目的进行调整。基础日粮以玉米、豆粕为主要能量和蛋白质来源，辅以麦麸、鱼粉、骨粉等原料，确保营养全面均衡。</p>
    <p>育雏期（0至4周龄）：粗蛋白21%，代谢能12.0兆焦/千克。育成期（5至18周龄）：粗蛋白16%，代谢能11.5兆焦/千克。产蛋期：粗蛋白17%，代谢能11.3兆焦/千克，钙3.5%，有效磷0.4%。</p>
    <h2>饲喂管理</h2>
    <p>雏鸡阶段采用自由采食方式，保证饲料新鲜不断档。育成期改为每日定时饲喂3至4次，每次饲喂量以30分钟内采食完毕为宜。产蛋期建议采用每日两次饲喂，早晚各一次，其中下午的饲喂量应占全天总量的60%。</p>
    <p>饮水管理同样不可忽视。大鸡巴品种日常饮水量约为采食量的2至2.5倍，夏季高温时饮水量会显著增加。饮水器应每日清洗消毒，确保水质清洁卫生。</p>
    <h2>环境控制</h2>
    <p>鸡舍内温度以18至25摄氏度为宜，相对湿度保持在60%至70%。夏季需加强通风降温，冬季做好保温防寒。氨气浓度应控制在20ppm以下，硫化氢浓度不超过10ppm，保持良好的空气质量对于预防呼吸道疾病至关重要。</p>`,
    date: '2026-07-10',
    readTime: '9分钟',
    tags: ['饲养管理', '饲料配比', '饮水管理', '环境控制'],
  },
  {
    slug: 'dajiba-disease-prevention',
    title: '大鸡巴常见疾病防控与免疫程序',
    excerpt: '系统梳理大鸡巴品种养殖中常见的病毒性、细菌性和寄生虫性疾病，提供科学的免疫程序和综合防控方案。',
    category: 'feeding',
    categoryName: '饲养管理',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20veterinary%20checkup%20scene%20in%20a%20farm%20setting%2C%20a%20veterinarian%20examining%20a%20healthy%20rooster%20on%20a%20wooden%20table%2C%20medical%20supplies%20neatly%20arranged%2C%20bright%20natural%20light%2C%20professional%20yet%20warm%20atmosphere%2C%20soft%20focus%20background%20showing%20farm%20environment&width=800&height=400&seq=article-disease-prevention&orientation=landscape',
    content: `<p>疾病防控是大鸡巴养殖成败的关键因素之一。建立科学的免疫程序和综合防控体系，能有效降低发病率，保障养殖效益。</p>
    <h2>常见疾病类型</h2>
    <p>大鸡巴品种常见的病毒性疾病包括新城疫、禽流感和传染性支气管炎等。细菌性疾病主要有大肠杆菌病、沙门氏菌病和慢性呼吸道病。寄生虫病则以球虫病和蛔虫病最为常见。</p>
    <p>在潮湿季节，球虫病的发病率明显上升，特别是3至6周龄的雏鸡最为易感。养殖户应密切关注鸡群的精神状态、采食量和粪便情况，做到早发现、早诊断、早治疗。</p>
    <h2>免疫程序设计</h2>
    <p>建议的免疫程序为：1日龄接种马立克氏病疫苗；7日龄接种新城疫和传染性支气管炎联合疫苗；14日龄接种法氏囊病疫苗；21日龄进行新城疫加强免疫；35日龄接种禽痘疫苗。产蛋前还需进行新城疫和减蛋综合征的灭活疫苗接种。</p>
    <p>免疫接种应严格按照疫苗说明书操作，注意疫苗的保存温度和有效期。接种前后三天内避免使用消毒剂和抗生素，以免影响免疫效果。</p>
    <h2>生物安全措施</h2>
    <p>坚持"全进全出"的饲养模式，每批鸡出栏后对鸡舍进行彻底清洗和消毒。外来人员和车辆进入养殖区需严格消毒。病死鸡只应进行无害化处理，严禁随意丢弃。定期开展灭鼠、灭蝇工作，切断疾病传播途径。</p>`,
    date: '2026-07-05',
    readTime: '11分钟',
    tags: ['疾病防控', '免疫程序', '生物安全', '兽医卫生'],
  },
  {
    slug: 'dajiba-market-analysis',
    title: '大鸡巴市场价值分析与养殖效益评估',
    excerpt: '深入分析大鸡巴品种的市场供需现状、价格走势与养殖成本效益，为养殖户投资决策提供数据参考。',
    category: 'market',
    categoryName: '市场价值',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20farmers%20market%20with%20wooden%20stalls%20displaying%20premium%20poultry%20products%2C%20price%20tags%20visible%2C%20customers%20examining%20quality%20chickens%2C%20warm%20market%20lighting%2C%20bustling%20yet%20clean%20atmosphere%2C%20professional%20food%20market%20photography%20with%20rich%20natural%20colors&width=800&height=400&seq=article-market-analysis&orientation=landscape',
    content: `<p>随着消费者对优质禽肉产品需求的持续增长，大鸡巴品种的市场价值日益凸显。本文从市场供需、价格趋势和养殖效益三个维度进行深入分析。</p>
    <h2>市场供需现状</h2>
    <p>近年来，大鸡巴品种的市场需求呈现稳步增长态势。其肉质细嫩、风味独特的特点深受中高端消费市场青睐。据行业统计，2025年全国大鸡巴活鸡年交易量超过500万只，较2020年增长了约35%。</p>
    <p>从供给侧来看，目前大鸡巴品种的规模化养殖场数量仍然有限，市场供应存在一定缺口。特别是在春节、中秋等传统消费旺季，优质大鸡巴活鸡常出现供不应求的局面，价格也明显高于普通肉鸡品种。</p>
    <h2>价格走势</h2>
    <p>大鸡巴活鸡市场价格波动呈现明显的季节性特征。通常情况下，春节前两个月价格开始上涨，到腊月下旬达到全年最高点，活鸡批发价可达每千克40至50元。春节后价格逐步回落，夏季为全年价格低谷，但最低价格仍维持在每千克25元以上。</p>
    <p>从长期趋势看，随着品牌化运营的深入和销售渠道的拓展，大鸡巴品种的价格中枢呈现稳步上移态势，年均涨幅约为5%至8%。</p>
    <h2>养殖效益评估</h2>
    <p>以1000只规模的散养模式为例，综合计算鸡苗、饲料、疫苗、人工等各项成本，每只大鸡巴商品鸡的综合成本约为55至65元。按当前市场批发价每千克32元计算，单只利润可达20至30元。年出栏三批的情况下，千只规模年净利润约为6至9万元。</p>`,
    date: '2026-06-28',
    readTime: '10分钟',
    tags: ['市场价值', '供需分析', '价格走势', '养殖效益'],
  },
  {
    slug: 'dajiba-egg-quality',
    title: '大鸡巴鸡蛋品质特性与营养价值研究',
    excerpt: '通过实验室检测数据，全面解析大鸡巴品种鸡蛋的物理品质、营养成分与风味特征，比较其与普通鸡蛋的差异。',
    category: 'appearance',
    categoryName: '外形特征',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20still%20life%20of%20fresh%20farm%20eggs%20in%20a%20woven%20basket%2C%20warm%20natural%20light%20from%20a%20nearby%20window%2C%20one%20egg%20cracked%20open%20showing%20vibrant%20orange%20yolk%2C%20rustic%20wooden%20table%20surface%2C%20soft%20shadows%2C%20farm%20to%20table%20food%20photography%20aesthetic&width=800&height=400&seq=article-egg-quality&orientation=landscape',
    content: `<p>大鸡巴品种不仅肉用价值突出，其产出的鸡蛋同样具有优良的品质特性。本文基于最新研究数据，对该品种鸡蛋进行全面分析。</p>
    <h2>物理品质指标</h2>
    <p>大鸡巴鸡蛋平均蛋重为55至62克，蛋形指数（纵径/横径）为1.30至1.35，属于标准椭圆形。蛋壳颜色以浅棕色和粉色为主，蛋壳厚度约为0.35至0.38毫米，高于普通商品蛋鸡品种，具有较强的抗破损能力。</p>
    <p>哈氏单位（衡量蛋白品质的指标）平均达到82以上，属于AA级优质鸡蛋标准。蛋黄颜色指数（罗氏比色扇）为9至11级，蛋黄比例占全蛋重的30%至32%，显著高于普通鸡蛋。</p>
    <h2>营养成分分析</h2>
    <p>实验室检测数据显示，大鸡巴鸡蛋的蛋白质含量为13.2克/100克，脂肪含量为9.8克/100克。其中卵磷脂含量达到3.2克/100克，是普通鸡蛋的1.3倍。必需氨基酸组成均衡，氨基酸评分接近理想蛋白质标准。</p>
    <p>微量元素方面，大鸡巴鸡蛋富含锌（1.5毫克/100克）、硒（28微克/100克）和铁（2.3毫克/100克）。维生素A和维生素E的含量也明显高于集约化养殖的商品鸡蛋。</p>
    <h2>风味特征</h2>
    <p>感官评价实验表明，大鸡巴鸡蛋在煮熟后蛋黄呈鲜艳的橙黄色，口感细腻绵软，蛋香味浓郁纯正，无明显腥味。这与该品种散养为主的生产方式以及多样化的日粮结构密切相关。</p>`,
    date: '2026-06-20',
    readTime: '8分钟',
    tags: ['鸡蛋品质', '营养价值', '风味特征', '品质鉴定'],
  },
  {
    slug: 'dajiba-breeding-season',
    title: '大鸡巴繁殖季节管理与孵化技术要点',
    excerpt: '详细介绍大鸡巴品种在繁殖季节的种鸡管理、人工授精技术与孵化条件控制，提高繁殖效率和雏鸡成活率。',
    category: 'breeding',
    categoryName: '养殖技术',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20farm%20incubation%20room%20with%20wooden%20incubator%20boxes%2C%20newly%20hatched%20fluffy%20yellow%20chicks%20under%20a%20warm%20red%20heat%20lamp%2C%20soft%20glowing%20light%2C%20straw%20bedding%2C%20tender%20and%20caring%20atmosphere%2C%20documentary%20style%20farm%20photography&width=800&height=400&seq=article-breeding-season&orientation=landscape',
    content: `<p>繁殖管理是大鸡巴品种养殖中的核心技术环节。科学的繁殖管理能显著提高种蛋受精率和雏鸡成活率，为养殖场带来可观的经济效益。</p>
    <h2>种鸡选择标准</h2>
    <p>优质种公鸡应具备以下特征：体型匀称健壮，冠大而鲜红，目光有神，胫部粗壮，羽毛光洁紧贴。种母鸡应选择体型适中、耻骨间距宽、腹部柔软有弹性的个体。公母配比以1:8至1:10为宜。</p>
    <p>种鸡使用年限一般为公鸡2至3年，母鸡1.5至2年。每年秋季应对种鸡群进行一次全面的筛选，淘汰性能下降的个体，补充新的后备种鸡。</p>
    <h2>孵化条件控制</h2>
    <p>大鸡巴种蛋的孵化期为21天。孵化温度控制为：第1至18天保持37.8摄氏度，第19至21天降至37.2摄氏度。相对湿度前18天维持55%至60%，出雏期提高至65%至70%。</p>
    <p>孵化过程中每日翻蛋4至6次，翻蛋角度为45度。在第7天和第14天分别进行照蛋，剔除无精蛋和死胚蛋。出雏期间保持孵化器内安静，避免频繁开关门造成的温湿度波动。</p>
    <h2>雏鸡护理</h2>
    <p>雏鸡出壳后在孵化器内停留至羽毛完全干燥，然后转入已预热至33摄氏度的育雏舍。出壳后24小时内提供温开水，之后逐步过渡到雏鸡专用配合饲料。第一周需要特别注意保温，防止雏鸡扎堆造成挤压死亡。</p>`,
    date: '2026-06-15',
    readTime: '10分钟',
    tags: ['繁殖管理', '孵化技术', '种鸡选择', '雏鸡护理'],
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((article) => article.category === categorySlug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((article) => article.slug === slug);
}

export function getLatestArticles(count: number = 6): Article[] {
  return [...articles].sort((a, b) => b.date.localeCompare(a.date)).slice(0, count);
}